export interface CuriosityData {
  id: string;
  name: string;
  subtitle?: string; // moved to translations
  description?: string; // moved to translations
  image: string;
  category: string;
  link: string;
}

export const curiositiesData: Record<string, CuriosityData> = {
  'wildlife': {
    id: 'wildlife',
    name: 'Wildlife',
    image: '/curiosities/wildlife/wildlife_homepage.webp',
    category: 'Natura',
    link: '/curiosities/wildlife'
  },
  'gastronomy': {
    id: 'gastronomy',
    name: 'Gastronomia',
    image: '/curiosities/gastronomy/gastronomy_homepage.webp',
    category: 'Cucina',
    link: '/curiosities/gastronomy'
  },
  'history': {
    id: 'history',
    name: 'History',
    image: '/curiosities/history/history_homepage.webp',
    category: 'Cultura',
    link: '/curiosities/history'
  }
};

export const getCuriosityData = (curiosityId: string): CuriosityData | null => {
  return curiositiesData[curiosityId] || null;
};
